import axios from "axios";
import cookiesService from "@/services/cookiesServiceNoAwait";

// Function to apply interceptors and utility methods to an Axios instance
const applyInterceptorsAndUtils = (instance) => {
  instance.interceptors.request.use(
    (config) => {
      const authToken = cookiesService.getCookie("authToken");
      if (authToken?.token) {
        config.headers["Authorization"] = `Bearer ${authToken.token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const originalRequest = error.config || {};
      const currentToken = cookiesService.getCookie("authToken")?.token;
      const rejectedToken = originalRequest.headers?.Authorization;
      const tokenError = ["TokenExpiredError", "JsonWebTokenError"].includes(
        error.response?.data?.error?.name
      );
      const rejectedProfile =
        originalRequest.url === "/profile" && error.response?.status === 403;

      // Only invalidate the session used by this request, not a newer login.
      if (
        currentToken &&
        rejectedToken === `Bearer ${currentToken}` &&
        (error.response?.status === 401 || tokenError || rejectedProfile)
      ) {
        cookiesService.removeCookie("authToken");
      }
      if (error.response?.status === 401 && !originalRequest._retry) {
        if (originalRequest.url?.includes("/china-us/submission/form")) {
          return Promise.reject(error);
        }

        if (error.config.url == "/stem-studio/check-educators-guide") {
          console.log("no redirect");
        } else if (error.config.url == "/stem-studio/orders") {
          return error.response;
        } else {
          // Potentially handle redirection or token refresh here
          // window.location = `${
          //   process.env.VUE_APP_LOGIN_URL
          // }/request-login?ref_path=${encodeURIComponent(
          //   window.location.pathname
          // )}`;
        }
      }

      return Promise.reject(error);
    }
  );

  // Method to build URL with query params
  instance.getUrlWithParams = (url, params) => {
    if (!params || Object.keys(params).length === 0) {
      return url;
    }

    // filter params if value is not null, undefined, or empty string
    const queryParts = [];

    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((item) => {
          if (!item) return;

          queryParts.push(`${key}[]=${encodeURIComponent(item)}`);
        });
      } else if (!Array.isArray(value) && value) {
        queryParts.push(`${key}=${encodeURIComponent(value)}`);
      }
    });

    const queryString = queryParts.join("&");

    return `${url}?${queryString}`;
  };

  return instance;
};

// Default instance using environment variable
const defaultBaseURL = process.env.VUE_APP_API_URL
  ? `${process.env.VUE_APP_API_URL}/api`
  : "/api"; // Provide a fallback if the env var is not set

const http = axios.create({
  baseURL: defaultBaseURL,
  headers: {
    "Content-type": "application/json",
  },
});

applyInterceptorsAndUtils(http);

// Function to create a new instance with an optional custom base URL
export const createHttpInstance = (customBaseURL) => {
  const baseURL = customBaseURL || defaultBaseURL;
  const newInstance = axios.create({
    baseURL: baseURL,
    headers: {
      "Content-type": "application/json",
    },
  });

  applyInterceptorsAndUtils(newInstance);

  return newInstance;
};

// Export the default instance
export default http;
